<template>
    <div>
        <div v-if="errors.length > 0" class="alert alert-bad">
            <ul>
                <li v-for="error in errors" :key="error"><span class="fa fa-flag"></span>{{ error }}</li>
            </ul>
        </div>

        <div v-if="!hasCurrentPhoto" class="input-container">
            <div class="input-title">{{ title }}</div>
            <div class="input-box">
                <label :for="id" class="input-file-upload"><span class="fa fa-cloud-upload"></span>{{ !hasFiles ? 'Choose Image' : 'Choose Different Image' }}</label>
                <input :id="id" :name="name" ref="fileInput" type="file" @change="loadImagesFromFile">
            </div>
        </div>
        <div v-if="hasCurrentPhoto && !hasFiles" class="input-container">
            <div class="input-title">Current {{ title }}</div>
            <div class="current-image">
                <img :src="currentImage">
                <div v-if="canRemove" class="buttons"><delete-button @deleted="replaceCurrent" text="Remove" confirm-text="Confirm Remove"></delete-button></div>
            </div>
        </div>
        <div v-if="hasCurrentPhoto" class="input-container">
            <div class="input-title">Replace {{ title }}</div>
            <div class="input-box">
                <label :for="id" class="input-file-upload"><span class="fa fa-cloud-upload"></span>Choose New {{ title }}</label>
                <input :id="id" :name="name" ref="fileInput" type="file" @change="loadImagesFromFile">
            </div>
        </div>
        <div v-if="hasFiles" class="input-container">
            <div class="input-title">{{ previewTitle }}</div>
            <!--<div class="input-box"><input type="text" disabled value="file-name-goes-here.jpg"><span class="fa fa-camera"></span></div>-->
            <div class="current-image">
                <img :src="fileData">
                <div class="buttons"><delete-button @deleted="clearSelectedFile"></delete-button></div>
            </div>
        </div>
        <div v-if="hasFiles" class="input-container">
            <div class="input-box static-text"><b>Note:</b> If your photo appears sideways, don’t worry. It will appear upright after you submit the form.</div>
        </div>
        <!--<div class="input-container">-->
            <!--<div class="input-title">Current Image</div>-->
            <!--<div class="current-image">-->
                <!--<a href="https://static1.squarespace.com/static/53ed0e3ce4b0c296acaeae80/57f4d399440243d357b24ad7/5a4e04150d9297b75329123d/1515062399381/PLANTE-4058-Edit+Headshot+Photography+by+Tommy+Collier+Productions+Denver+Colorado+Headshots+Photographer.jpg?format=1500w" target="_blank"><img src="https://static1.squarespace.com/static/53ed0e3ce4b0c296acaeae80/57f4d399440243d357b24ad7/5a4e04150d9297b75329123d/1515062399381/PLANTE-4058-Edit+Headshot+Photography+by+Tommy+Collier+Productions+Denver+Colorado+Headshots+Photographer.jpg?format=1500w"></a>-->
                <!--<div class="buttons"><a href="" class="bad-bg inline-button-margins">Confirm Delete<span class="fa fa-trash"></span></a><a href="" class="neutral-bg inline-button-margins">Cancel<span class="fa fa-times-circle"></span></a></div>-->
            <!--</div>-->
        <!--</div>-->
        <!--<div class="input-container">-->
            <!--<div class="input-title">Replace Image</div>-->
            <!--<div class="input-box">-->
                <!--<label for="file-upload" class="input-file-upload"><span class="fa fa-cloud-upload"></span>Choose Replacement Image</label>-->
                <!--<input id="file-upload" type="file">-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>

import _ from 'underscore';

export default {

    props: {
        currentPhoto: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: 'Image',
        },
        previewTitle: {
            type: String,
            default: 'Image To Upload',
        },
        name: {
            type: String,
        },
        photoKey: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            currentImage: this.currentPhoto,
            form: { files: [] },
            fileData: null,
            errors: [],
            id: _.uniqueId('photo'),
        };
    },

    watch: {
        currentPhoto(newValue) {
            this.currentImage = newValue;
        },
    },

    computed: {

        hasFiles() {
            return this.form.files && this.form.files.length > 0;
        },

        hasCurrentPhoto() {
            return (this.currentImage && this.currentImage.length > 0);
        },

        canRemove() {
            return !!this.photoKey.type;
        },

    },

    methods: {

        loadImagesFromFile(ev) {
            this.errors = [];
            const file = ev.target.files[0];

            if (!file.type.match('image.*')) {
                this.errors = [ 'You can only select photos' ];
                this.clearSelectedFile();
            }

            this.form.files = ev.target.files;
            const reader = new FileReader();

            reader.onload = e => this.fileData = e.target.result;
            reader.readAsDataURL(file);
        },

        clearSelectedFile(done = null) {
            this.fileData = null;
            this.form.files = [];
            this.$refs.fileInput.value = '';

            if (done) {
                done();
            }
        },

        async replaceCurrent(done) {
            if (!this.canRemove) return;

            const { data } = await axios.post('/photos/delete', this.photoKey);

            if (data.success) {
                this.currentImage = '';
            }
            done();
        }
    },

}

</script>



// WEBPACK FOOTER //
// resources/js/components/elements/form/PhotoUpload.vue